import { ChatPage } from '@/components/polix-ai-v2/chat-page'

export function PolixAIV2Page() {
  return (
    <div className="h-full w-full">
      <ChatPage />
    </div>
  )
}

